/**
 * @desc 获取可顺延的订单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/${id}/getCapablePostponementOrder`, {
      method: "GET",

      ...options,
    }),
  );
}
